import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export default dayjs;



// WEBPACK FOOTER //
// ./src/utils/dateTimeHelpers.js